export const isCustomerPageContext = () => window.location.hostname.match(/(minesider|minasidor|mypages|my-pages|stabla-local|pr-1360|192|127.0.0|172.16.10.83)\./);

export const isCustomerPageNorway = () => !window.location.hostname.match(/\.se$/);
